/** อาวุธลับ (lane C4 skeleton): steel + ink, motif chips. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const HIDDENARTS_FX: ReturnType<typeof makeHandArt> = makeHandArt('hidden-arts', { a: 'steel', b: 'ink', motif: 'chips' }, [
  ['hw-dart', 'throw', 4],
  ['hw-snare', 'grab'],
  ['hw-knives', 'throw', 6],
  ['hw-rain', 'throw', 9],
  ['hw-caltrops', 'throw', 7],
  ['hw-smoke', 'buff'],
  ['hw-aim', 'buff'],
  ['hw-stars', 'power', 7],
]);
